import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'

const useStyles = makeStyles(() => {
  return ({
    brandedDocument: {
      borderRadius: 'var(--border-radius-lg)',
      minHeight: '180px',
      width: '220px',
      padding: '.5rem',
      border: '2px solid var(--color-primary-100)',
      boxShadow: '0px 7px 7px -5px rgba(0,0,0,0.5)',
      backgroundColor: 'var(--theme-color-surface-d0)',
      backgroundImage: ({ imageUrl }) => imageUrl ? `url(${imageUrl})` : undefined,
      backgroundPosition: ({ imagePadded }) => imagePadded ? 'center 45%' : 'center 25%',
      backgroundSize: ({ imagePadded }) => imagePadded ? '60%' : 'cover',
      backgroundRepeat: 'no-repeat',
      position: 'relative',
      transition: 'border .3s ease',
      '& > *:hover': {
        textDecoration: 'none !important'
      },
      '&:hover': {
        border: 'var(--border-primary-normal) !important',
        '& .__ds-title': {
          height: '54px'
        }
      },

      '& .__branded-document-title': {
        position: 'absolute',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        bottom: -2,
        left: 0,
        height: '36px',
        color: 'var(--color-primary-050)',
        width: '220px',
        fontSize: '0.85rem',
        padding: '.5rem',
        borderBottomLeftRadius: '12px',
        borderBottomRightRadius: '12px',
        backgroundColor: 'var(--color-primary-500)',
        transition: 'height .3s ease-in-out',
        overflow: 'auto'
      }
    }
  })
})

const BrandedDocument = ({ name, imageUrl, imagePadded, onHover, badges, style, className }) => {
  const classes = useStyles({ imageUrl, imagePadded })

  const badgeSection = useMemo(() => {
    if ((badges || []).length === 0) {
      return null
    }

    return (
      <div className='flex gap-xs items-center justify-center absolute top-0 right-0'>
        {badges.map((b, i) => (
          <div key={`badge-${i}`}>
            {b}
          </div>
        ))}
      </div>
    )
  }, [badges])

  return (
    <div
      className={clsx(classes.brandedDocument, className)}
      style={style}
      onMouseOver={onHover}
    >
      {badgeSection}
      <div className='__branded-document-title'>{name}</div>
    </div>
  )
}

BrandedDocument.propTypes = {
  name: PropTypes.string.isRequired,
  imageUrl: PropTypes.string,
  imagePadded: PropTypes.bool,
  onHover: PropTypes.func,
  badges: PropTypes.arrayOf(PropTypes.node),
  className: PropTypes.string,
  style: PropTypes.object
}

BrandedDocument.defaultProps = {
  onHover: () => {}
}

export default BrandedDocument
